import { useState, useEffect } from 'react';
import { useMouseListeners } from '../hooks/useMouseListeners';
import { Focus, KeyboardEventLike, NavTree } from '../navigation/typings';
import { fromCoords, triggerFocus, blur } from '../navigation/utils';
import { useContextMenuContext } from '../contexts/ContextMenuContext/ContextMenuContext';
import { resolve } from '../navigation/resolve';
import { singleContainerTransitions } from '../navigation/transitions';

const firstButtonFocus = fromCoords({
  row: 0,
  column: -4,
  offset: 0,
});

type HookReturn = {
  triggerNavigation: (e: KeyboardEventLike) => void;
  focus: Focus;
};

export const useContextMenuNavigation = (buttons: unknown[]): HookReturn => {
  const { isContextMenuOpen } = useContextMenuContext();
  const [focus, setFocus] = useState<Focus>(firstButtonFocus);

  const navTree: NavTree = [
    {
      content: buttons,
      constraint: { width: 1 },
    },
  ];

  const handleFocusChange = (newFocus: Focus) => {
    setFocus(newFocus);
    document.getElementById(newFocus.id)?.focus();
  };

  function triggerNavigation(e: KeyboardEventLike) {
    const getContainer = () => navTree[0];
    handleFocusChange(
      resolve({
        currentContainer: navTree[0],
        currentFocus: focus,
        getContainer,
        keyCode: e.keyCode,
        transitions: singleContainerTransitions,
      })
    );
  }

  useMouseListeners(200, () => blur(focus));

  useEffect(() => {
    if (!isContextMenuOpen) return;
    triggerFocus(focus, true);
  }, [focus, isContextMenuOpen, buttons]);

  return {
    triggerNavigation,
    focus,
  };
};
